<template>
    <div class="container my-3">
        <CardContent title="SmartLog">
            <template v-slot:breadcumb>
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/material-public">
                            <i class="feather icon-home"></i>
                        </router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="">Bookmark Material</router-link>
                    </li>
                </ol>
            </template>

            <template v-slot:action>
                <div class="row align-items-center justify-content-between">
                    <div class="col mb-1">
                        <div class="d-flex justify-content-start">

                            <button type="button" class="btn btn-outline-primary" style="margin-left: 4px;"
                                data-toggle="modal" data-target="#filterModal">
                                Filter
                            </button>

                            <div class="dropdown" style="margin-left: 4px;">
                                <button class="btn btn-outline-primary" type="button" id="dropdownSortButton"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Sort by
                                </button>
                                <div class="dropdown-menu" style="min-width: 230px;"
                                    aria-labelledby="dropdownSortButton">
                                    <a class="dropdown-item d-flex justify-content-between" href="#"
                                        @click.prevent="sortBy('created_at', 'desc')">
                                        Terbaru
                                        <span v-if="currentSort == 'created_at' && currentSortDir == 'desc'">✔</span>
                                    </a>
                                    <a class="dropdown-item d-flex justify-content-between" href="#"
                                        @click.prevent="sortBy('created_at', 'asc')">
                                        Terdahulu
                                        <span v-if="currentSort == 'created_at' && currentSortDir == 'asc'">✔</span>
                                    </a>
                                    <a class="dropdown-item d-flex justify-content-between" href="#"
                                        @click.prevent="sortBy('name', 'asc')">
                                        Nama Material A-Z
                                        <span v-if="currentSort == 'name' && currentSortDir == 'asc'">✔</span>
                                    </a>
                                    <a class="dropdown-item d-flex justify-content-between" href="#"
                                        @click.prevent="sortBy('name', 'desc')">
                                        Nama Material Z-A
                                        <span class="mr-2"
                                            v-if="currentSort == 'name' && currentSortDir == 'desc'">✔</span>
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="col-12 col-sm-4 mb-1">
                        <div class="d-flex justify-content-start align-items-center">

                            <router-link to="/material-public" class="mr-1 btn btn-outline-primary">
                                Kembali
                            </router-link>

                            <SearchInput v-model="search" placeholder="Cari" />
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:content>
                <div v-if="materials.data?.length == 0">
                    <h5 class="text-center text-primary">Data not found!</h5>
                </div>

                <div class="row" v-if="materials.data?.length > 0">
                    <div class="col-md-4 col-sm-6 col-12 mb-1" v-for="(item, key) in materials.data"
                        :key="key">
                        <MaterialCard :item="item" @bookmark="toggleBookmark" />
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-12 text-center">
                        <h5 class="font-weight-bold text-secondary">Data Kosong</h5>
                    </div>
                </div>

                <div class="row d-flex justify-content-center" v-if="materials.data?.length > 0">
                    <PaginateList :data="materials" />
                </div>

                <!-- modal filter -->
                <ModalB4 title="Filter" id="filterModal">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">Sub Kategori</label>
                                <multiselect v-model="selectedSubCategories" :options="sub_categories" :multiple="true"
                                    placeholder="Select" selected-label="✔" select-label="✔" deselect-label="✖"
                                    label="name" track-by="id" :close-on-select="false"
                                    @input="filters.sub_category_ids = selectedSubCategories.map(item => item.id)">
                                    <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                    <template #selection="{ values }">
                                        <span v-if="values.length > 0" class="multiselect__single">
                                            {{ values.length }} selected
                                        </span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="">UPP</label>
                                <multiselect v-model="selectedUnits" :options="units" :multiple="true"
                                    placeholder="Select" select-label="✔" deselect-label="✖" label="name" track-by="id"
                                    :close-on-select="false"
                                    @input="filters.unit_ids = selectedUnits.map(item => item.id)">
                                    <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                    <template #selection="{ values }">
                                        <span v-if="values.length > 0" class="multiselect__single">
                                            {{ values.length }} selected
                                        </span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="formSelectGuadang">Gudang</label>
                                <multiselect v-model="selectedWarehouses" :options="gudangs" :multiple="true"
                                    placeholder="Select" select-label="✔" deselect-label="✖" label="name" track-by="id"
                                    :close-on-select="false"
                                    @input="filters.warehouse_ids = selectedWarehouses.map(item => item.id)">
                                    <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                    <template #selection="{ values }">
                                        <span v-if="values.length > 0" class="multiselect__single">
                                            {{ values.length }} selected
                                        </span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <label for="formSelectKategoriMaterial">Kategori Material</label>
                                <multiselect v-model="filters.material_categories" :options="['PDP', 'Non PDP', 'ATTB']"
                                    :multiple="true" placeholder="Select" select-label="✔" deselect-label="✖"
                                    :close-on-select="false">
                                    <!-- Slot untuk mengganti tampilan yang muncul di input -->
                                    <template #selection="{ values }">
                                        <span v-if="values.length > 0" class="multiselect__single">
                                            {{ values.length }} selected
                                        </span>
                                    </template>
                                </multiselect>
                            </div>
                        </div>
                    </div>

                    <template #footer>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-primary"
                            @click="resetFilters">Reset</button>
                        <button type="button" data-dismiss="modal" class="btn btn-primary"
                            @click.prevent="getList">Simpan</button>
                    </template>
                </ModalB4>
                <!-- modal filter end -->
            </template>

        </CardContent>
    </div>
</template>


<script>
import PaginateList from '@/components/PaginateList.vue'
import SearchInput from '@/components/SearchInput.vue'
import CardContent from '@/components/CardContent.vue'
import MaterialCard from './MaterialCard.vue'
import ModalB4 from '@/components/ModalB4.vue'

export default {
    name: 'MaterialIndexPublic',
    components: {
        PaginateList, SearchInput, CardContent, MaterialCard, ModalB4
    },
    data() {
        return {
            selectedUnits: [],
            selectedSubCategories: [],
            selectedWarehouses: [],
            materials: [],
            gudangs: [],
            sub_categories: [],
            categories: [],
            units: [],
            search: null,
            filters: {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            },
            tab_category: '',
            currentSort: 'created_at',
            currentSortDir: 'desc',
            currentPage: 1,
        }
    },
    mounted() {
        let _ = this
        _.getList()
        _.getUnit()
        _.getGudang()
        _.getSubCategory()
        _.getCategory()
        // Listen for pagination events
        _.$root.$on("paginate", (data) => {
            _.getList(data)
        });
        window.$('[data-toggle="tooltip"]').tooltip()
    },
    beforeDestroy() {
        this.$root.$off("paginate");
        window.$('[data-toggle="tooltip"]').tooltip();
    },
    beforeCreate() {
        window.$('[data-toggle="tooltip"]').tooltip('dispose');
    },
    methods: {
        resetFilters() {
            this.selectedSubCategories = [];
            this.selectedUnits = [];
            this.selectedWarehouses = [];
            this.filters = {
                sub_category_ids: [],
                warehouse_ids: [],
                unit_ids: [],
                material_categories: [],
            };
            this.getList();
        },
        getList(page) {
            let _ = this
            if (page) {
                _.currentPage = page // update currentPage jika ada argumen
            }
            const bookmark_ids = JSON.parse(localStorage.getItem('material_public_bookmarked')) || []
            _.axios.get('/materials', {
                params: {
                    page: _.currentPage,
                    search: _.search,
                    sort: _.currentSortDir,
                    orderby: _.currentSort,
                    category_id: _.tab_category,
                    bookmark_ids,
                    ..._.filters,
                }
            })
                .then(resp => {
                    const dataFetch = resp.data.data
                    // kalau data kosong dan bukan halaman 1, geser ke halaman sebelumnya
                    if ((dataFetch.data?.length === 0 || dataFetch.length === 0) && _.currentPage > 1) {
                        _.currentPage--
                        _.getList(_.currentPage)
                        return
                    }

                    _.materials = bookmark_ids.length > 0 ? dataFetch : []
                })
                .catch(err => { // jika masih error, gunakan data dummy
                    console.log(err.response)
                })
        },
        getGudang() {
            let _ = this
            _.axios.get('/warehouses?unit_ids=')
                .then(resp => {
                    _.gudangs = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        selectCategory(id) {
            let _ = this
            _.tab_category = id
            _.getSubCategory()
        },
        getSubCategory() {
            let _ = this
            _.axios.get('/categories', {
                params: {
                    parent_id: _.tab_category
                }
            })
                .then(resp => {
                    let all_category = resp.data.data
                    _.sub_categories = all_category.filter(item => item.parent_id !== 0);
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getCategory() {
            let _ = this
            _.axios.get('/categories?parent_id=0')
                .then(resp => {
                    _.categories = resp.data.data
                })
                .catch(err => {
                    console.log(err.response)
                })
        },
        getUnit() {
            let _ = this
            _.axios.get('/unit')
                .then(resp => {
                    _.units = resp.data.data.data
                })
                .catch(err => {
                    console.log("gagal", err.response)
                })
        },
        sortBy(orderBy, sortDir) {
            this.currentSort = orderBy;
            this.currentSortDir = sortDir;
            this.getList()
        },
        getBookmarkIds() {
            const data = localStorage.getItem('material_public_bookmarked')
            return data ? JSON.parse(data) : []
        },
        saveBookmark(id) {
            const ids = this.getBookmarkIds()
            if (!ids.includes(id)) {
                ids.push(id)
                localStorage.setItem("material_public_bookmarked", JSON.stringify(ids))
            }
        },
        deletBookmark(id) {
            const ids = this.getBookmarkIds().filter(item => item !== id)
            localStorage.setItem("material_public_bookmarked", JSON.stringify(ids))
        },
        toggleBookmark(item) {
            if (this.isBookmarked(item.id)) {
                this.deletBookmark(item.id)
            } else {
                this.saveBookmark(item.id)
            }
            this.getList()
        },
        isBookmarked(id) {
            return this.getBookmarkIds().includes(id)
        },
    },
    computed: {
        materialPublicBookmarked() {
            const bookmarkIds = JSON.parse(localStorage.getItem('material_public_bookmarked')) ?? [];
            return this.materials.data.filter(item => bookmarkIds.includes(item.id))
        }
    },
    watch: {
        search: function () {
            this.getList()
        },
        tab_category: function () {
            this.selectedSubCategories = []
            this.filters.sub_category_ids = []
            this.getList()
        },
    }
}
</script>